import React, { Component } from 'react';
import { FormGroup,  FormFeedback, Label, Input,Row,Col } from 'reactstrap';
import moment from 'moment';

import * as Validations from '../validation/validations';
import * as FormLogic from './FormLogic'
import { run, validationRunner } from '../validation/validationRunner'


const fieldValidations = [
  validationRunner("GenderCode", "Geslacht", Validations.required),
  validationRunner("LastName", "Achternaam", Validations.required, Validations.minLength(2), Validations.maxLength(36)),
  validationRunner("Infix", "Tussenvoegsel", Validations.maxLength(32)),
  validationRunner("FirstName", "Voornaam", Validations.maxLength(36)),
  validationRunner("Initials", "Voorletter(s)", Validations.required, Validations.maxLength(32)),
  validationRunner("DateOfBirth", "Geboortedatum", Validations.required, Validations.validDate, Validations.validDateRange),
  validationRunner("NationalityCode", "Nationaliteit", Validations.required),
]


class RegistrationFormPersonData extends Component {
  constructor(props) {
    super(props);
    this.validate = false;

    this.state = {
      secondNationality: false,
      validationErrors: {},
      fieldsTouched: [],
      GenderCode: "",
      LastName: "",
      Infix: "",
      FirstName: "",
      Initials: "",
      DateOfBirth: "",
      NationalityCode: "NL",
      SecondNationalityCode: "",
    };

    this.setInitials = this.setInitials.bind(this);
    this.handleChangeDoB = this.handleChangeDoB.bind(this);

    this.handleChange = FormLogic.handleChange.bind(this);
    this.handleChangeCapitalizeWords = FormLogic.handleChangeCapitalizeWords.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.checkInvalid = FormLogic.checkInvalid.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);

    this.run = run.bind(this);
  }


  componentDidUpdate() {
    this.runValidations(false);
  }

  runValidations(ignoreTouched) {
    if (ignoreTouched) {
      this.validate = true
    }
    return this.run(fieldValidations);
  }

  getFormValues() {
    return {
      "LastName" : this.state.LastName,
      "Infix" : this.state.Infix,
      "FirstName" : this.state.FirstName,
      "Initials" : this.state.Initials,
      "DateOfBirth" : FormLogic.toDateFormat(this.state.DateOfBirth),
      "GenderCode" : this.state.GenderCode,
      "NationalityCode" : this.state.NationalityCode,
      "SecondNationalityCode" : this.state.SecondNationalityCode,
    }
  }

  handleChangeDoB(event) {
    this.handleChange(event);
    var age = moment().diff(moment(event.target.value, 'YYYYMMDD'), 'years')
    this.props.setIsMinor(age < 16);
  }


  setInitials(event) {
    const val = event.target.value.trim();
    if (!val) {
      this.setState({Initials: ""})
      return;
    }
    const cleaned = val.replace(/\s\s+/g, ' ');
    var splitValue = cleaned.split(' ');
    for (var i = 0; i < splitValue.length; i++) {
      splitValue[i] = splitValue[i].charAt(0).toUpperCase();
    }
    var initialsName = splitValue.join('.') + '.';
    this.setState({Initials: initialsName})
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={{size:3, offset:1}} />
          <Col md={6}>
            <h2>
              Persoonsgegevens
            </h2>
          </Col>
        </Row>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Geslacht *</Label>
          </Col>
          <Col md={7}>
            <FormGroup tag="fieldset">
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="GenderCode"
                    value="M"
                    innerRef={(input) => { this.GenderCode = input; }}
                    onChange={this.handleChange}
                    /> Man
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="GenderCode"
                    value="F"
                    invalid={this.checkInvalid("GenderCode")}
                    onChange={this.handleChange}
                    /> Vrouw
                    <FormFeedback className="AllignFeedbackBasedOnFather">{this.errorFor("GenderCode")}</FormFeedback>
                </Label>
              </FormGroup>
            </FormGroup>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label">Achternaam *</Label>
          </Col>
          <Col md={7}>
            <Input
              name="LastName"
              innerRef={(input) => { this.LastName = input; }}
              value={this.state.LastName}
              autoComplete="ignored-123456"
              onChange={this.handleChangeCapitalizeWords}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("LastName")}
              className="Input" />
            <FormFeedback>{this.errorFor("LastName")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" for="Infix" >Tussenvoegsel(s) </Label>
          </Col>
          <Col md={7}>
            <Input
              name="Infix"
              id="Infix"
              autoComplete="ignored-123456"
              innerRef={(input) => { this.Infix = input; }}
              value={this.state.Infix}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("Infix")}
              className="Input" />
            <FormFeedback>{this.errorFor("Infix")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row >
          <Col md={{size:3, offset:1}} >
            <Label className="Label" for="FirstName" >Voornaam </Label>
          </Col>
          <Col md={7}>
            <Input
              name="FirstName"
              id="FirstName"
              autoComplete="ignored-123456"
              innerRef={(input) => { this.FirstName = input; }}
              value={this.state.FirstName}
              onChange={(e) => {this.handleChangeCapitalizeWords(e); this.setInitials(e)}}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("FirstName")}
              className="Input" />
            <FormFeedback>{this.errorFor("FirstName")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" for="Initials" >Voorletter(s) * </Label>
          </Col>
          <Col md={7}>
            <Input
              name="Initials"
              id="Initials"
              autoComplete="ignored-123456"
              innerRef={(input) => { this.Initials = input; }}
              value={this.state.Initials}
              onChange={this.handleChangeCapitalizeWords}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("Initials")}
              className="Input" />
            <FormFeedback>{this.errorFor("Initials")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Geboortedatum *</Label>
          </Col>
          <Col md={7}>
            <Input
              name="DateOfBirth"
              innerRef={(input) => { this.DateOfBirth = input; }}
              value={this.state.DateOfBirth}
              type="date"
              date-format="dd/mm/yyyy"
              autoComplete="ignored-123456"
              onChange={this.handleChangeDoB}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("DateOfBirth")}
              className="Input" />
            <FormFeedback>{this.errorFor("DateOfBirth")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Nationaliteit * </Label>
          </Col>
          <Col md={7}>
            <Input
              name="NationalityCode"
              innerRef={(input) => { this.NationalityCode = input; }}
              type="select"
              autoComplete="ignored-123456"
              value={this.state.NationalityCode}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("NationalityCode")}
              className="Input" >
              {this.props.nationalities.map((country) => <option key={country.NationalityCode} value={country.NationalityCode}>{country.Nationality}</option>)  }
            </Input>
            <FormFeedback>{this.errorFor("NationalityCode")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" htmlFor="secondNationality" check> 2<sup>e</sup> Nationaliteit </Label>
          </Col>
          <Col md={7}>
            <Input
              name="SecondNationalityCode"
              innerRef={(input) => { this.SecondNationalityCode = input; }}
              type="select"
              autoComplete="ignored-123456"
              defaultValue={this.state.SecondNationalityCode}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("SecondNationalityCode")}
              className="Input"  >
                <option value=""></option>
                {this.props.nationalities.map((country) => <option key={country.NationalityCode} value={country.NationalityCode}>{country.Nationality}</option>)  }
            </Input>
            <FormFeedback>{this.errorFor("SecondNationalityCode")}</FormFeedback>
          </Col>
        </FormGroup>
    </div>
    );
  }
}
export default RegistrationFormPersonData



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationFormPersonData.jsx